module.exports = __webpack_public_path__ + "static/img/withdraw4.57435cce.jpg";